// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","loaderContainer":"circles-loader_loaderContainer__CYSy5","loaderCircle":"circles-loader_loaderCircle__wFdPX","active":"circles-loader_active__Eieb1"};